export { default as ShopCartFooter } from './ShopCartFooter';
